import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = { class: "message-container" }
const _hoisted_3 = { class: "actions-bar" }
const _hoisted_4 = { class: "btn-right-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.visible)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ModalCard, {
            "active-validate": false,
            contentMaxHeight: _ctx.height,
            headerTitle: _ctx.$t('modale.preavisIntervention.create.title'),
            height: _ctx.height,
            maxWidth: _ctx.maxWidth,
            width: _ctx.width,
            withoutBotNav: true,
            onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t('preavisIntervention.confirmation')), 1)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_ButtonWhite, {
                    "on-click": () => _ctx.$emit('close'),
                    text: _ctx.$t('button.close'),
                    class: "btn-left btn"
                  }, null, 8, ["on-click", "text"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_ButtonWhite, {
                      "on-click": () => _ctx.$emit('mes-preavis'),
                      text: _ctx.$t('preavisIntervention.consulter'),
                      class: "btn"
                    }, null, 8, ["on-click", "text"]),
                    (!_ctx.hideNouveauPreavis)
                      ? (_openBlock(), _createBlock(_component_ButtonBlue, {
                          key: 0,
                          "on-click": () => _ctx.$emit('nouveau-preavis'),
                          text: _ctx.$t('preavisIntervention.nouveau'),
                          class: "btn"
                        }, null, 8, ["on-click", "text"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["contentMaxHeight", "headerTitle", "height", "maxWidth", "width"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}